import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";

import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";
import ScrollToTopOnLoad from "./components/ScrollToTopOnLoad";

// Pages
import Home from "./pages/Home";

// Slider
import Slider from "react-slick";

// Landing Page Images
import banner1 from "./assets/banners/x1.jpg";
import banner2 from "./assets/banners/x2.jpg";
import banner3 from "./assets/banners/x3.jpg";
import banner4 from "./assets/banners/x4.jpg";
import banner5 from "./assets/banners/x5.jpg";

function LandingPage() {
  const navigate = useNavigate();

  const heroSlides = [
    { image: banner1, buttonText: "", buttonLink: "/home" },
    { image: banner2, buttonText: "", buttonLink: "/" },
    { image: banner3, buttonText: "", buttonLink: "/" },
    { image: banner4, buttonText: "", buttonLink: "/" },
    { image: banner5, buttonText: "", buttonLink: "/" }
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: true
  };

  return (
    <div className="home-container">
      <section className="hero-slider">
        <Slider {...sliderSettings}>
          {heroSlides.map((slide, index) => (
            <div key={index} className="hero-slide">
              <img
                src={slide.image}
                alt={`Slide ${index + 1}`}
                className="hero-image"
              />
              <div className="hero-overlay"></div>
            </div>
          ))}
        </Slider>
      </section>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTopOnLoad />

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/home"
          element={
            <>
              <Navbar />
              <Home />
              <Footer />
            </>
          }
        />
      </Routes>

      <ScrollToTopButton />
    </Router>
  );
}

export default App;
